/**
 * Was am Handy sonst nur im Grundkalender stünde: die Übertragungen dieses Apartments mit dem Weg in
 * den Verlauf, „Alles neu übertragen“ (nur Full) und die Legende.
 */
import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import type { AvailabilityDistributionCalendarResponse } from '@/shared/api';
import { AvailabilityDistributionOperationList } from '../AvailabilityDistributionOperationList';
import { CalendarLegend } from '../calendar/CalendarLegend';
import { FullResyncDialog } from '../calendar/FullResyncDialog';

interface Props {
  data: AvailabilityDistributionCalendarResponse;
  apartmentId: string;
  canFullSync: boolean;
  onChanged: () => void;
}

export function MonthMobileExtras({ data, apartmentId, canFullSync, onChanged }: Props) {
  const [resync, setResync] = useState(false);
  const apartment = data.apartments.find((entry) => entry.propertyId === apartmentId);
  if (!apartment) return null;
  const count = apartment.operations.length;
  return (
    <>
      {count > 0 && (
        <details className="bg-card border-hairline rounded-tile border px-4">
          <summary className="min-h-14 cursor-pointer content-center text-sm font-bold">
            Übertragungen · {count >= 20 ? '20+' : count}
          </summary>
          <AvailabilityDistributionOperationList operations={apartment.operations} />
          <Link
            to="/properties/$id/preise"
            params={{ id: apartmentId }}
            className="text-forest inline-flex min-h-11 items-center text-[13px] font-bold"
          >
            Verlauf im Apartment öffnen
          </Link>
        </details>
      )}
      {canFullSync && (
        <button
          type="button"
          onClick={() => setResync(true)}
          className="bg-card border-hairline rounded-tile min-h-14 border px-4 text-left text-sm font-bold"
        >
          Alles neu übertragen
        </button>
      )}
      <CalendarLegend apartments={[apartment]} closeouts={data.channelCloseouts} />
      {resync && (
        <FullResyncDialog
          apartments={data.apartments}
          preselectedPropertyId={apartmentId}
          onClose={() => setResync(false)}
          onFinished={onChanged}
        />
      )}
    </>
  );
}
